









import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class SCounter extends Vue {
  @Prop([ String, Number ]) public count?: string | number | null;
  @Prop(Object) public type?: object | null;
  @Prop(HTMLElement) public element?: HTMLElement;
  @Prop(Number) public id?: number;
}
